import { CartState } from './types'

export const state: CartState = {
	items: [],
	removedItems: [],
	shipping: 0,
	shippingAddress: null,
	billingAddress: null,
	deliveryInstructions: '',
	deliveryDate: null,
	paymentMethod: '',
	discountCode: '',
	referral: '',
	channel: ''
}
